var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2242 15.496H7.8422C7.5332 15.496 7.2832 15.246 7.2832 14.937V10.555C7.2832 10.246 7.5332 9.996 7.8422 9.996H9.2242C9.5332 9.996 9.7832 10.246 9.7832 10.597V14.979C9.7832 15.245 9.5332 15.496 9.2242 15.496Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.78323 14.311L10.8652 15.208C11.0892 15.394 11.3722 15.496 11.6632 15.496H15.2462C15.6952 15.496 16.0902 15.198 16.2142 14.766L16.9462 12.204C17.0572 11.817 16.9922 11.4 16.7692 11.065C16.5172 10.686 16.0942 10.459 15.6412 10.459H15.0212H13.9762L13.9812 8.757C13.9852 7.492 12.3242 7.022 11.6642 8.101L9.78223 11.182",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6065 3.271L14.0565 2.562C14.7255 2.235 15.5345 2.497 15.8835 3.156L16.6405 4.582C16.8405 4.958 17.2025 5.221 17.6225 5.295L19.2125 5.574C19.9465 5.703 20.4455 6.39 20.3415 7.128L20.1155 8.726C20.0555 9.148 20.1945 9.574 20.4905 9.88L21.6125 11.04C22.1305 11.575 22.1305 12.425 21.6125 12.961L20.4905 14.121C20.1945 14.427 20.0555 14.853 20.1155 15.275L20.3415 16.873C20.4455 17.611 19.9465 18.298 19.2125 18.427L17.6225 18.706C17.2025 18.78 16.8405 19.043 16.6405 19.419L15.8835 20.845C15.5345 21.503 14.7265 21.766 14.0565 21.439L12.6065 20.73C12.2235 20.543 11.7765 20.543 11.3935 20.73L9.94352 21.439C9.27452 21.766 8.46552 21.504 8.11652 20.845L7.35952 19.418C7.15952 19.042 6.79752 18.779 6.37752 18.705L4.78752 18.426C4.05352 18.297 3.55452 17.61 3.65852 16.872L3.88452 15.274C3.94452 14.852 3.80552 14.426 3.50952 14.12L2.38752 12.96C1.86952 12.425 1.86952 11.575 2.38752 11.039L3.50952 9.879C3.80552 9.573 3.94452 9.147 3.88452 8.725L3.65952 7.127C3.55452 6.39 4.05452 5.702 4.78852 5.574L6.37852 5.295C6.79752 5.221 7.15952 4.958 7.35952 4.582L8.11652 3.156C8.46552 2.498 9.27352 2.235 9.94352 2.562L11.3935 3.271C11.7755 3.458 12.2235 3.458 12.6065 3.271Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.911feeae5429571fda178b482c8760c8.svg";
export { ForwardRef as ReactComponent };